// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__13ka7","inner":"Form_inner__3KHoI","range":"Form_range__32HzG","name":"Form_name__pIM_B","actions":"Form_actions__3P13w"};